import { render, staticRenderFns } from "./EmployerConfirm.vue?vue&type=template&id=5b6c0702&scoped=true"
import script from "./EmployerConfirm.vue?vue&type=script&lang=js"
export * from "./EmployerConfirm.vue?vue&type=script&lang=js"
import style0 from "./EmployerConfirm.vue?vue&type=style&index=0&id=5b6c0702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c0702",
  null
  
)

export default component.exports